<template>
  <div id="header">
    <div class="header-box">
      <router-link to="/"><img class="logo" src="../assets/images/logo.png"></router-link>

      <div :class="navAct?'nav-box':'nav-box active'" :style="navH">
        <ul>
          <li v-for="(iten,index) in navdata" @click="mainChoose(iten.name)"  :class="$store.state.highlight==iten.name?'head-li active':'head-li'"><router-link v-if="iten" :to="iten.url">{{iten.title}}</router-link></li>
          <!-- <li><span :class="language=='Japanese'?'head-li active':'head-li'" @click="languageChoose('Japanese')">日本語</span>|<span :class="language=='english'?'active':''" @click="languageChoose('english')">EN</span></li> -->
        </ul>
      </div>
      <div class="navbar-toggle" @click="navToggle()">
      	<span class="sr-only"></span>
      	<span class="icon-bar"></span>
      	<span class="icon-bar"></span>
      	<span class="icon-bar"></span>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        navdata:'',
        navAct:true,
        navH:{
          height:'auto'
        },
        heiAct:0,
        language:'Japanese'
      }
    },
    props: {
        resData: {}
    },
    watch: {
        resData(newData){
          this.navdata=newData;
        }
    },
    methods:{
      mainChoose(type){
        this.heiAct=type;
		this.$store.state.highlight=type;
        this.navToggle();
      },
      languageChoose(val){
        this.language=val;
        this.$parent.languagefun(val);
        this.navToggle();
      },
      navToggle(){
        if (document.body.clientWidth<1000) {
          this.navAct=!this.navAct;
          let h=document.getElementsByTagName('li')[0].offsetHeight*document.getElementsByClassName('head-li').length;
          if (this.navAct) {
            this.navH={
              height:0
            }
          } else{
            this.navH={
              height:h+'px'
            }
          }
        }
      }
    },
    mounted() {
      let this_=this;
      this.$store.state.highlight=this.$route.name;
      console.log(this.$store.state.highlight);
      this.$parent.getlan();
      this.language=this.$parent.languages;
      if (document.body.clientWidth<1000) {
        this.navH={
          height:0
        }
      }
      window.addEventListener("resize",function(){
          if (document.body.clientWidth<1000) {
            this_.navH={
              height:0
            }
          }else{
            this_.navH={
              height:'auto'
            }
          }
      })
    }
  }
</script>

<style scoped>
  .header-box{
    height: 105px;
    max-width: 1200px;
    margin: auto;
    position: relative;
  }
  .logo{
    height: 75px;
    margin: 15px 0;
  }
  .nav-box{
    float: right;
    font-size: 0;
  }
  .nav-box li{
    display: inline-block;
    font-size: 18px;
    line-height: 105px;
    cursor: pointer;
    font-weight: 700;
  }
  .nav-box li a{
    padding: 0 20px;
    color: black;
    display: block;
  }
  .nav-box li.active a{
    color: #57749C;
  }
  .nav-box li span{
    display: inline-block;
    margin: 0 5px;
  }
  .nav-box li span.active{
    color: #57749C;
  }
  .navbar-toggle {
      position: absolute;
      right: 3%;
      padding: 9px 10px;
      margin-top: 28px;
      margin-right: 15px;
      background-color: white;
      background-image: none;
      border: 1px solid #ddd;
      border-radius: 4px;
      display: none;
      cursor: pointer;
  }
  .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      border: 0;
  }
  .navbar-toggle .icon-bar {
      display: block;
      width: 22px;
      height: 2px;
      border-radius: 1px;
      background-color: #888;
  }
  .navbar-toggle .icon-bar + .icon-bar {
      margin-top: 4px;
  }
  @media screen and (max-width: 1000px){
    .header-box{
      height: 90px;
      max-width: 750px;
    }
    .logo{
      height: 60px;
      margin: 15px 10px;
      float: left;
    }

    .nav-box{
      float: left;
      width: 100%;
      position: absolute;
      z-index: 20;
      background-color: white;
      top: 90px;
      transition: all .2s ease-in;
      height: 0;
      overflow: hidden;
    }
    .nav-box ul{
      padding: 0 5%;
    }
    .nav-box li{
      line-height: initial;
      display: block;
      width: 100%;
      text-align: left;
      box-sizing: border-box;
      font-size: 16px;
      border-top: 1px solid #ddd;
    }
    .nav-box li a{
      padding: 3% 0;
    }
    /* .nav-box li:nth-last-of-type(1){
      text-align: center;
      padding: 3% 0;
    } */
    .nav-box li span{
      margin:0 10%;
    }
    .navbar-toggle{
    	display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header.vue